"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryButton = void 0;
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _internal = require("../../hooks/internal");
var _BuyButton = require("../BuyButton");
var _SubscribeButton = require("../SubscribeButton");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PrimaryButton = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    currentShade: {
      canBeSold,
      canBeSubscribed,
      productCode,
      subscription: {
        available
      }
    }
  } = (0, _internal.useProduct)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    isSubscriptionReplacement
  } = (0, _internal.useReplaceSubscriptionData)();
  const {
    personalSubscriptionsEnabled
  } = (0, _internal.useSharedConfiguration)();
  const subscriptionsButtonWrapperTestId = `${_constants.SUBSCRIPTIONS_ADD_TO_BAG}-${productCode}`;
  if (!isSubscriptionReplacement && available && personalSubscriptionsEnabled && canBeSold) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubscriptionsButtonWrapper, {
      id: subscriptionsButtonWrapperTestId,
      "data-testid": getTestId(subscriptionsButtonWrapperTestId)
    });
  }
  if (!isSubscriptionReplacement && !canBeSold && !personalSubscriptionsEnabled && canBeSubscribed) {
    if (isAnonymousUser) {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscribeButton.SubscribeButton, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_BuyButton.BuyButton, {});
};
exports.PrimaryButton = PrimaryButton;
